<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>

.app-main {
  width: 100%;
  height: calc(100% - 50px);
  position: relative;
  // 路由切换动画（transition.scss 的 fade-transform）会把离场页面 translateX(30px) 移出视口右侧，
  // 不裁剪时文档会短暂出现横向滚动条；横向滚动条要占掉约 15px 视口高度，
  // 而侧边栏是 position:fixed + bottom:0，底部「退出」按钮就被顶上去，store/order 互切时来回闪动。
  // 用 clip 而不是 hidden：只裁剪横向，overflow-y 仍是 visible（页面高于视口时依旧由文档纵向滚动）；
  // 用 hidden 会把 overflow-y 算成 auto，等于把整个页面变成内层滚动容器。
  overflow-x: clip;
  margin: 0 auto;
}

.fixed-header + .app-main {
  height: 100%;
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    height: calc(100% - 84px);
  }

  .fixed-header + .app-main {
    height: 100%;
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

// 老浏览器（Safari < 16、Chrome < 90）不支持 overflow-x: clip，
// 上面的裁剪会失效；这类浏览器直接去掉离场页面的横向位移，
// 只保留淡出，避免又出现横向滚动条把侧边栏底部「退出」按钮顶得闪动
@supports not (overflow-x: clip) {
  .fade-transform-leave-to {
    transform: none;
  }
}
</style>
